export default __webpack_public_path__ + "static/31_july_2021-4d4ec215a360b82b9379b71ef4d363a7.jpeg";